import { BehaviorSubject } from "rxjs";

export enum MainViewInstruction{
    NONE=0,
    AUTH,
    LANDING,
    ERROR
}

export interface MainViewRX{
    testMessage:string    
    mainViewInstruction:MainViewInstruction
}


var initialPanelStates:MainViewRX={
    testMessage:'Initial Panel States Applied',
    mainViewInstruction:MainViewInstruction.AUTH
}

/**
The subject is converted to an Observable when a subscriber pre-filters the pipe.
In order to set state back into this, a subject would need to be subscribed raw and a next call made
 */
export const mainViewPresenter$ = new BehaviorSubject<MainViewRX>(initialPanelStates);

mainViewPresenter$.subscribe(
    (data)=> {
        testStateInstruction(data);
    }
)

function testStateInstruction(output:MainViewRX){
    //ConsoleOutRXMessageSource("App Presentation State output => " +  output.testMessage);
}





export async function changeMainView(    
    mainViewInstruction:MainViewInstruction
):Promise<MainViewRX>{
    var returnState:MainViewRX = {
        testMessage:'Updated Main Presenter State => ' + MainViewInstruction[mainViewInstruction].toString(),
        mainViewInstruction:mainViewInstruction
    }

    mainViewPresenter$.next(returnState);

    return returnState;
}
